"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _gerenciatdUnifiedicons = require("@bit/gerenciatd.unifiedicons.svg-icon");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var pathMedium = /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Fragment, {
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M-9.555-5.4h-1.933v-.909h1.933V-8.238h.909v1.933H-6.7V-5.4H-8.646v1.947h-.909ZM-1.26-.9A3.531,3.531,0,0,1-3.6-1.617a2.365,2.365,0,0,1-.858-1.9,2.6,2.6,0,0,1,.534-1.594A3.949,3.949,0,0,1-2.5-6.276a3.88,3.88,0,0,1-1.154-.988,2.224,2.224,0,0,1-.418-1.378,2.354,2.354,0,0,1,.368-1.305,2.474,2.474,0,0,1,1.017-.887A3.341,3.341,0,0,1-1.2-11.152a3.234,3.234,0,0,1,1.479.325,2.509,2.509,0,0,1,1,.866,2.108,2.108,0,0,1,.353,1.176,2.4,2.4,0,0,1-.469,1.45A3.391,3.391,0,0,1-.164-6.291,5.885,5.885,0,0,1,1.452-5.173a2.1,2.1,0,0,1,.577,1.522A2.585,2.585,0,0,1,1.617-2.2a2.662,2.662,0,0,1-1.154.966A4.115,4.115,0,0,1-1.26-.9Zm.216-5.828Q.514-7.517.514-8.7A1.351,1.351,0,0,0,.045-9.753a1.783,1.783,0,0,0-1.233-.418,1.949,1.949,0,0,0-1.277.4,1.3,1.3,0,0,0-.483,1.06,1.408,1.408,0,0,0,.483,1.1A6.412,6.412,0,0,0-1.044-6.723Zm-.2,4.832A2.422,2.422,0,0,0,.269-2.324,1.441,1.441,0,0,0,.831-3.535a1.466,1.466,0,0,0-.325-.959,2.68,2.68,0,0,0-.757-.642q-.433-.245-1.342-.678a3.507,3.507,0,0,0-1.233.938A1.967,1.967,0,0,0-3.28-3.608a1.554,1.554,0,0,0,.541,1.269A2.276,2.276,0,0,0-1.246-1.891Zm7.992,1A2.809,2.809,0,0,1,4.164-2.2a7.326,7.326,0,0,1-.808-3.816,7.367,7.367,0,0,1,.808-3.823,2.805,2.805,0,0,1,2.582-1.313A2.805,2.805,0,0,1,9.328-9.839a7.367,7.367,0,0,1,.808,3.823A7.326,7.326,0,0,1,9.328-2.2,2.809,2.809,0,0,1,6.746-.9Zm0-1.024A1.7,1.7,0,0,0,8.4-2.9a7.466,7.466,0,0,0,.483-3.116A7.519,7.519,0,0,0,8.4-9.14a1.693,1.693,0,0,0-1.652-.988,1.693,1.693,0,0,0-1.652.988,7.519,7.519,0,0,0-.483,3.123A7.466,7.466,0,0,0,5.094-2.9,1.7,1.7,0,0,0,6.746-1.92Z",
    transform: "translate(15.5 22)",
    fill: "#fff"
  })
});

var Mas80 = function Mas80(props) {
  var kind = props.kind;
  var path = null;

  switch (kind) {
    default:
      path = pathMedium;
  }

  var Icon = (0, _gerenciatdUnifiedicons.CreateSvgIcon)(path, "Mas80-".concat(kind));
  var viewBox = props.viewBox,
      mainDimension = props.mainDimension;

  if (!viewBox) {
    viewBox = '4 5.5 21.8 21.8';
  }

  if (!mainDimension) {
    mainDimension = 'x';
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, _objectSpread(_objectSpread({}, props), {}, {
    viewBox: viewBox,
    mainDimension: mainDimension
  }));
};

var _default = Mas80;
exports["default"] = _default;

//# sourceMappingURL=index.js.map